export default "__VITE_ASSET__967fb629__"